export default "__VITE_ASSET__cab5b995__"